/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geostyleheat2Inputs */

const en_geostyleheat2 = /** @type {(inputs: Geostyleheat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heatmap`)
};

const de_geostyleheat2 = /** @type {(inputs: Geostyleheat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heatmap`)
};

/**
* | output |
* | --- |
* | "Heatmap" |
*
* @param {Geostyleheat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geostyleheat2 = /** @type {((inputs?: Geostyleheat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geostyleheat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geostyleheat2(inputs)
	return de_geostyleheat2(inputs)
});
export { geostyleheat2 as "geoStyleHeat" }